export const AMIR_COIN = {
  name: "AMIR",
  symbol: "AMIR",
  chain: "Solana",
  mint: "DSDVXdNTbmVqjzANUiX5vw3zR9TQf94A79ce5L84pump",
  pumpUrl: "https://pump.fun/coin/DSDVXdNTbmVqjzANUiX5vw3zR9TQf94A79ce5L84pump",
  solscanUrl: "https://solscan.io/token/DSDVXdNTbmVqjzANUiX5vw3zR9TQf94A79ce5L84pump",
  communityUrl: "https://pump.fun/communities/DSDVXdNTbmVqjzANUiX5vw3zR9TQf94A79ce5L84pump",
  logo: "https://ipfs.io/ipfs/QmbimYxLfUDJfqbS2GKXyoxHEbPs55GWt3HPRqrfcNcmkj",
  description:
    "Inspired by my twin boys King and Amir. They were born in the N.I.C.U. I wanted a coin that represents the little man's struggle. My boys were born at 24 weeks and are miracles. The boys are almost 3 and doing extremely well. GOD bless you.",
};

export function shortMint(mint = AMIR_COIN.mint) {
  return `${mint.slice(0, 4)}…${mint.slice(-4)}`;
}

export const AMIR_TOKEN = {
  totalSupply: "1,000,000,000",
  launch:
    "Fair launch on pump.fun — no presale, no private allocation, no team pre-mint. Everyone buys on the same open bonding curve from the very first block.",
  // Use cases — what AMIR is actually for
  useCases: [
    "A symbol of acknowledgement — holding AMIR says 'I stand with NICU families and this movement.'",
    "Community recognition — thank and uplift each other around a shared purpose.",
    "Rallying support and awareness for premature, trach, and g-tube babies.",
    "A hopeful reminder that A Miracle is Real.",
  ],
  // Public rules — how the token works, verifiable on-chain
  rules: [
    "Fixed total supply of 1,000,000,000 AMIR — the pump.fun standard, unchangeable.",
    "No mint authority and no freeze authority — supply can't be inflated and wallets can't be frozen.",
    "Liquidity follows pump.fun's standard bonding curve and is locked/burned on graduation to a DEX.",
    "The contract address is public and the same for everyone — always verify before you buy.",
  ],
  // Commitments — principles this project holds itself to
  commitments: [
    "No hidden control — the token follows public, on-chain rules, not private levers.",
    "Transparency first — links below let anyone independently verify supply, holders, and activity.",
    "Purpose over hype — AMIR exists to acknowledge a movement, not to promise financial returns.",
  ],
  // Optional: set to a public wallet address to display live, verifiable fund flows
  treasuryWallet: null,
};

